export default __webpack_public_path__ + "static/media/Movie.fe1b60a3.png";